module.exports = __webpack_public_path__ + "assets/images/project/map-logo-svg/tablet1.png?v=de4b6f25";